import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2377537677/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
